<template>
<div class="boxs">
  <div id="box">
    <div class="boxc">
      <div class="newico">最新公告</div>
      <div id="con1" ref="con1" :class="{anim:animate==true}"> 
        <div v-for='item in notices_list'>{{item.n_title}}</div>
      </div>
    </div>
  </div>
  <div id="box-c">
    <div class="b-search">
    <input class="btn-search" ref="search" type="text" name="search" value="" placeholder="    搜索...">
    <div class="ico" @click="searchlotto()"></div>
  </div>
  </div>
  
</div>
</template>
<script>
  import bus from '../assets/js/eventBus'
  export default {
    data() {
      return {
        animate: false,
        notices_list: []
      }
    },
    created() {
      setInterval(this.scroll,2500)
    },
    mounted:function () {
      let self = this;
      this.getNotices(self);
    },
    methods: {
      searchlotto() {
        var searchname = this.$refs.search.value.toUpperCase();
        var searchdata = JSON.parse(this.$store.state.search);
        var searchresult = '';
        if(searchname) {
          for(var i in searchdata) {
            if(searchdata[i].indexOf(searchname) != -1){
              searchresult +=  i+','
            }
          }
          if(searchresult) {
            bus.$emit('search',searchresult)
            this.$router.push({ name: 'Home', params: {lottoName: searchresult}})
          } 
        }    
      },
      scroll() {
        this.animate=!this.animate;
        var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
        setTimeout(function(){
            that.notices_list.push(that.notices_list[0]);
            that.notices_list.shift();
            that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
        },1500)
      },
      getNotices(e) {
        this.$api.getNotices()
        .then(function (response) {
          e.notices_list = response.data
        })
        .catch(function (error) {
          console.log('服务器加载异常');
        });
      }
  }
}
</script>
<style scoped>
.boxs {
  position: relative;
}
#box {
  width: 100%;
  height: 30px;
  position: relative;
  background-color: #000000;
  opacity: 0.6;
}
#box-c {
  width: 100%;
  height: 30px;
  position: absolute;
  top: 0px;
}
@media screen and (max-width: 1281px){
  .boxc {
    width: 1024px;
  }
  .b-search {
    width: 1024px;
    position: relative;
    margin: 0 auto;
    top:0px;
  }
}
@media screen and (min-width: 1281px){
  .boxc {
    width: 1280px;
  }
  .b-search {
    width: 1280px;
    position: relative;
    margin: 0 auto;
    top:0px;
  }
} 
.boxc {
  height: 30px;
  margin: 0 auto;
  overflow: hidden;
  transition: all 0.5s;
}
.anim {
  transition: all 0.5s;
  margin-top: -30px;
}
#con1 {
  margin-left: 88px;
  height: 30px;
}
#con1 div {
  list-style: none;
  line-height: 30px;
  height: 30px;
  color: #ffffff;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
}
.newico {
  color: #ff9c00;
  line-height: 30px;
  height: 30px;
  float: left;
}

.btn-search {
  width: 246px;
  height: 30px;
  color: #ffffff;
  float: right;
  line-height: 30px;
  background-color: #000000 !important;
  position: relative;
  border: 1px ;
  outline:none;
  cursor: pointer;
  z-index: 4;
  text-indent: 10px;
}
.ico {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 5;
  background: url(./../assets/search.png) no-repeat 
}
</style>


// WEBPACK FOOTER //
// src/components/Notices.vue